import { Component, Vue, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';

@Component
export default class Header extends Vue {
   public title: string = 'Header';

   public userName: string = '';

   public nav(route: string) {
      this.$router.push(`/${route}`);
   }

   public handleSignOut() {
      const _this: any = this;
      const browserStore = _this.$browserStore;
      browserStore.clearSession();
      this.$store.commit('logOut');
      this.$router.push('/login');
   }

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public onLoading(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         this.userName = val.partner.name;
      }
   }
}
